import { render, staticRenderFns } from "./OutboundConfiguration.vue?vue&type=template&id=7affafaa"
import script from "./OutboundConfiguration.vue?vue&type=script&lang=js"
export * from "./OutboundConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports